/**
 * 데이터 JSON 핫리로드 시 플레이 맵을 현재 위치에서 다시 연다.
 */

import Phaser from 'phaser';
import { registerAnimations } from '../assets/animations';
import { DATA_RELOAD_EVENT } from '../data/catalog';
import { hydrateGameData } from '../data/hydrate';
import { REG } from '../scenes/BootScene';
import type { AssetTable } from '../assets/loader';
import type { PlayerState } from '../systems/PlayerState';

export function bindDataHotReload(game: Phaser.Game): void {
  const apply = async (refetch: boolean): Promise<void> => {
    if (refetch) {
      try {
        await hydrateGameData();
      } catch (err) {
        console.warn('[data] 핫리로드 실패', err);
        return;
      }
    }

    const assets = game.registry.get(REG.assets) as AssetTable | undefined;
    const state = game.registry.get(REG.state) as PlayerState | undefined;
    const live = game.scene.getScenes(true)[0];
    if (assets && live) registerAnimations(live, assets);

    if (game.scene.isActive('play') && state?.mapId) {
      game.scene.getScene('play').scene.restart({ mapId: state.mapId, spawnId: state.spawnId });
    }
    console.info('[data] 테이블을 다시 읽었습니다');
  };

  window.addEventListener(DATA_RELOAD_EVENT, () => {
    void apply(false);
  });

  if (import.meta.hot) {
    import.meta.hot.on('game-data-changed', () => {
      void apply(true);
    });
  }
}
